import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { Amplify } from 'aws-amplify';
import awsmobile from './amplify/aws-exports';

import { AppModule } from './app/app.module';
import { Environment } from './environments/environment';

import * as Sentry from "@sentry/angular";
import { BUILD_NUMBER, PACKAGE_VERSION } from './version';

Sentry.init({
  dsn: "https://e50bc86b93154969a17242508b80d1db@o188102.ingest.sentry.io/4505356208898048",
  integrations: [
    Sentry.browserTracingIntegration(),
  ],

  tracePropagationTargets: [
    "localhost",           // Android uses http://localhost
    /^capacitor:\/\//,     // iOS
    /^ionic:\/\//,         // Alternative iOS protocol (if using Ionic)
    /^https:\/\/yourserver\.io\/api/  // Your actual API
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  environment: Environment.ENV,
  release: `${PACKAGE_VERSION}-${BUILD_NUMBER}`,
});

// TODO: Dynamic amplify config like old app
Amplify.configure(awsmobile);

if (Environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(ref => {
    const _window: any = window;
    let { ngRef } = _window;
    if (ngRef) {
      ngRef.destroy();
    }
    _window['ngRef'] = ref;
  })
  .catch(err => console.log(err));
